import React from 'react';
import ReactDom from 'react-dom';

import ErrorBoundary from '../Components/ErrorBoundary/index.jsx';


/**
 * Class for loading and rendering all registered entrypoints within the page.
 */
class Loader {
  constructor(document, entryPoints) {
    this.document = document;
    this.entryPoints = entryPoints;
  }

  load() {
    var elements = this.document.querySelectorAll('[data-react-component]');

    if (elements && elements.length) {
      for (var i = 0; i < elements.length; i++) {
        var element = elements[i];
        var componentName = element.dataset.reactComponent;

        for (var j = 0; j < this.entryPoints.length; j++) {
          var ep = this.entryPoints[j];

          if (ep.id() == componentName) {
            ReactDom.render(
              <ErrorBoundary>
                {ep.renderElement(element)}
              </ErrorBoundary>,
              element
            );
          }
        }
      }
    }
  }
}


export default Loader;

